// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"9c796736","327":"8f98cf77","357":"627ce7d2","419":"0fb2d10c","490":"005d2b04","553":"f30bdf8c","677":"21d68431","735":"430164ac","787":"b32fb4f2"}[chunkId] + ".chunk.js";
};